module.exports = __webpack_public_path__ + "img/avatar_Feb_2026.0898d283.jpg";